import { isDev, getEnvVar } from '../utils/env';

export const API_CONFIG = {
  baseURL: isDev() ? 'http://localhost:3000' : getEnvVar('API_URL', 'https://dendromap.fr'),
  timeout: 20000,
  /** Longer timeout for multipart uploads (large images on slow connections). */
  uploadTimeout: 120000,
  version: 'v1',
} as const;

console.log('API_CONFIG', API_CONFIG);

export * from './inventaire-type-colors';